import VisibleView from "components/hoc/VisibleView";
import { GatewayWidgetAttribute, WidgetProps } from "types";
import { StorageChart, StatusChart } from "./charts";
import ChartActionDropdown from "../ChartActionDropdown";
import MultiGwStatus from "./cards/MultiGwStatus";
import MultiGwStatusBar from "./cards/MultiGatewayUptime";
import SingleGatewayCard from "./cards/SingleGatewayCard";
import { ChartSource, ChartType } from "constant/chart";
import { useCallback, useEffect, useState } from "react";

const sourceChartMap = [
    {
        source: ChartSource.MULTIPLE_GATEWAYS,
        chart: ChartType.CARD_STATUS,
        component: MultiGwStatus,
    },
    {
        source: ChartSource.MULTIPLE_GATEWAYS,
        chart: ChartType.CARD_MULTIPLE_BARS,
        component: MultiGwStatusBar,
    },
    {
        source: ChartSource.SINGLE_GATEWAY,
        chart: ChartType.CARD_GATEWAY,
        component: SingleGatewayCard,
    },
    {
        source: ChartSource.STORAGE,
        chart: ChartType.DONUT,
        component: StorageChart,
    },
    {
        source: ChartSource.SINGLE_GATEWAY,
        chart: ChartType.DONUT,
        component: StatusChart,
    },
];

const getComponent = (source: ChartSource, chart: ChartType) => {
    const mapping = sourceChartMap.find(
        (item) => item.source === source && item.chart === chart
    );

    if (mapping) {
        return mapping.component;
    }

    return null;
};

type DeviceInfo = {
    gatewayId: string;
    gatewayName: string;
    id: string;
};

const GatewayWidget = ({
    gatewaysConfig,
    zoomLevel,
    panel,
    panel: { source, chart, attributes },
    dashboardId,
    onDelete,
    allRegistry,
}: WidgetProps) => {
    const Component = getComponent(source, chart);
    const [deviceConfig, setDeviceConfig] = useState<DeviceInfo[]>([]);

    const fetchGatewayInfo = useCallback(async () => {
        const gateways = (attributes as GatewayWidgetAttribute[]).map(
            ({ gateway_id }) => {
                const devices = gatewaysConfig[gateway_id];
                return {
                    gatewayId: gateway_id,
                    gatewayName: devices?.[0]?.gatewayName || "",
                    id: gateway_id,
                };
            }
        );

        setDeviceConfig(gateways);
    }, [attributes, gatewaysConfig]);

    useEffect(() => {
        fetchGatewayInfo();
    }, [attributes, fetchGatewayInfo]);

    return (
        <>
            {Component && (
                <div className="position-relative h-100">
                    <ChartActionDropdown
                        panelId={panel.uuid}
                        dashboardId={dashboardId}
                        onDelete={onDelete}
                        panel={panel}
                        deviceConfig={deviceConfig}
                    />
                    <VisibleView>
                        <Component
                            gatewaysConfig={gatewaysConfig}
                            zoomLevel={zoomLevel}
                            panel={panel}
                            dashboardId={dashboardId}
                            onDelete={onDelete}
                            allRegistry={allRegistry}
                        />
                    </VisibleView>
                </div>
            )}
        </>
    );
};

export default GatewayWidget;
